// Import rss-parser via its pre-built browser dist
//import 'rss-parser/dist/rss-parser.min.js'
//export const rssParser = new RSSParser()

export interface UrlEncodeRawData {
  [key: string]: string | string[] | number;
}

export const urlEncode = (data: UrlEncodeRawData): string => {
  const queryString = [];

  for (const key in data) {
    if (Array.isArray(data[key])) {
      const dk = data[key] as string[];
      dk.forEach((d) => {
        const encodedKey = encodeURIComponent(`${key}[]`);
        const encodedValue = encodeURIComponent(d);
        queryString.push(`${encodedKey}=${encodedValue}`);
      });
    } else {
      const encodedKey = encodeURIComponent(key);
      const encodedValue = encodeURIComponent(data[key] as string);
      queryString.push(`${encodedKey}=${encodedValue}`);
    }
  }

  return queryString.join('&');
};

export const formData = (data: UrlEncodeRawData): FormData => {
  const body = new FormData();

  Object.keys(data).forEach((key) => {
    body.append(key, data[key] as string);
  });

  return body;
};

export const itunesBaseUrl: string = 'https://itunes.apple.com';

export const isErrorResponse = (response: Response) =>
  response.status < 200 || response.status >= 300;
